function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#403f41}.cls-2{fill:#b3b5b6}.cls-3{fill:#77c7c4}.cls-4{fill:#6c6e70}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_67"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_67-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_59",
  d: "M99.292 31.534a9.287 9.287 0 0 0-3.3-7.377 12.743 12.743 0 0 0-8.533-2.837h-11.469v5.118h11.472a6.369 6.369 0 0 1 4.321 1.5 4.9 4.9 0 0 1 1.74 3.861 4.768 4.768 0 0 1-1.723 3.801 6.519 6.519 0 0 1-4.328 1.433h-5.64v-7.743h-5.832v12.846h11.469a12.254 12.254 0 0 0 8.489-3.027 9.839 9.839 0 0 0 3.334-7.575z",
  className: "cls-1",
  transform: "translate(54.812 15.588) translate(-75.99 -21.32)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_60",
  d: "M117.53 31.537a9.8 9.8 0 0 0 3.349 7.567 12.254 12.254 0 0 0 8.489 3.027h10.068v-5.088h-10.069a6.456 6.456 0 0 1-4.307-1.448 4.769 4.769 0 0 1-1.726-3.787 4.915 4.915 0 0 1 1.726-3.861 6.31 6.31 0 0 1 4.314-1.5h10.068v-5.117h-10.067a12.777 12.777 0 0 0-8.54 2.837 9.262 9.262 0 0 0-3.305 7.37z",
  className: "cls-1",
  transform: "translate(54.812 15.588) translate(-87.158 -21.323)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_61",
  d: "M209.717 21.33h-5.835v12.24l-12.627-11.355a3.005 3.005 0 0 0-2.325-.855 2.436 2.436 0 0 0-1.879.709 2.538 2.538 0 0 0-.651 1.806v18.264h5.835v-12.211l12.627 11.355a3.4 3.4 0 0 0 2.581 1.009c1.535 0 2.281-.885 2.281-2.691v-18.271z",
  className: "cls-1",
  transform: "translate(54.812 15.588) translate(-105.673 -21.323)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_62",
  d: "M184 15.595h-22.98v5.118h8.576v15.691h5.835v-15.691h8.569z",
  className: "cls-1"
})), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_63",
  d: "M126.211 20.714l4.811-5.118h-20.845v20.809h19.829v-5.1h-13.994v-2.9h13.994v-4.876h-13.994v-2.815z",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_64",
  d: "M83.319 20.18h-2.705l-2.04-5.5h6.78z",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_70"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_65",
  d: "M23.426 9.819l3.875-2.237v-5.345l-3.875-2.237z",
  className: "cls-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_66",
  d: "M9.161 33.085v-15.033l12.949-7.472v-10.58l-21.452 12.386a1.314 1.314 0 0 0-.658 1.14v24.774l.007.073z",
  className: "cls-3"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_67",
  d: "M35.991 46.69l-12.957 7.487-12.883-7.443-9.161 5.293 21.386 12.35a1.322 1.322 0 0 0 1.316 0l21.453-12.386.015-.007z",
  className: "cls-4",
  transform: "translate(-.266 -12.552)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_68",
  d: "M54.893 15.136l-8.5-4.906v5.337l-9.143 5.279 9.139 5.272v9.622l9.161 5.286v-24.749a1.346 1.346 0 0 0-.657-1.141z",
  className: "cls-2",
  transform: "translate(27.236 7.48) translate(-37.25 -10.23)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_69",
  d: "M18.228 23.288l.007 10.478 8.891-5.133v-10.478z",
  className: "cls-4"
})));

var SvgDcent = function SvgDcent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDcent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dcent.a676d65b.svg";
export { ForwardRef as ReactComponent };